import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SectionStyled = styled.section`
  margin-bottom: 7.2rem;
`;

export const SectionTitleStyled = styled.h3`
  ${typography.bold[18]};
  color: ${colors.neutral[700]};
  text-transform: uppercase;
  margin: 0 0 1.6rem;
`;

export const SectionSubtitleStyled = styled.h4`
  ${typography.regular[16]};
  color: ${colors.neutral[700]};
  margin: 0 0 1.6rem;
`;

export const ProposalsCardWrapperStyled = styled.div`
  position: relative;
`;
